<template>
  <div class="app-check-sim-card">
    <SimonModal
      :is-visible="showStatusInfoModal"
      @hide="showStatusInfoModal = false"
      id="play-info-modal"
    >
      <template v-slot:modalTitle>
        <slot name="headerModalESimStatus" v-if="statusInfoModal === 'esim'"></slot>
        <slot name="headerModalRemoveESimStatus" v-else-if="statusInfoModal === 'esimInstalled'"></slot>
        <slot name="headerModalSimStatus" v-else></slot>
      </template>
        <div class="app-check-sim-card-modal">
          <slot name="txtESimStatusInfoModal" v-if="statusInfoModal === 'esim'"></slot>
          <slot name="txtRemoveESimInfoModal" v-else-if="statusInfoModal === 'esimInstalled'"></slot>
          <slot name="txtSimStatusInfoModal" v-else></slot>
        </div>
    </SimonModal>
    <div class="card-wrapper esim-data" v-if="showCheckEsim">
      <div class="card">
        <div>
          <div><slot name="lblESimHeadline">eSIM-Daten</slot></div>
          <table class="check-sim-card-wrapper selfservice" v-if="eSimStatus && !eSimUnavailable">
            <tbody>
            <tr class="row check-sim-card-row" v-if="iccId !== null">
              <td class="text">
                <slot name="lblESimStatus">Status</slot>
                <a class="info-link-icon" @click="openInfoModal('esim')"></a>
              </td>
              <td class="value">
                <slot name="lblESimStatusInactive" v-if="!eSimInstalled">Inaktiv</slot>
                <slot name="lblESimStatusActive" v-else>aktiv</slot>
              </td>
            </tr>
            <tr class="row check-sim-card-row row-with-button" v-if="!eSimInstalled">
              <td class="text">
                <slot name="lblESimProfil">Profil</slot>
              </td>
              <td class="value">
                <a :href="esimPushTargetUrl" class="button setup-button"><slot name="lblESimProfilLink">Lorem, ipsum.</slot></a>
              </td>
            </tr>
            <tr class="row check-sim-card-row" v-else-if="eID !== null">
              <td class="text">
                <slot name="lblESimEID">eID</slot>
              </td>
              <td class="value">
                {{ eID }}
              </td>
            </tr>
            </tbody>
          </table>
          <div v-else-if="eSimUnavailable" class="infoBox">
            <slot name="txtESimUnavailable"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="card-wrapper sim-data">
      <div class="card">
        <div class="app-check-sim-card">
          <div >
            <slot name="lblSimHeadline">SIM-Daten</slot>
          </div>
          <table class="check-sim-card-wrapper selfservice" v-if="currentCustomer !== null && mnpOutStatus !== null">
            <tbody>
            <tr class="row check-sim-card-row id" v-if="iccId !== null">
              <td class="text">
                <slot name="lblIccId">SIM-Seriennummer</slot>
              </td>
              <td class="value">
                {{ iccId }}
              </td>
            </tr>
            <tr class="row check-sim-card-row puk" v-if="pukView !== null">
              <td class="text">
                <slot name="lblPUK">PUK</slot>
              </td>
              <td class="value">
                {{ pukView }}
              </td>
            </tr>
            <tr class="row check-sim-card-row provider" v-if="provider !== null">
              <td class="text">
                <slot name="lblProvider">Anbieterkennung</slot>
              </td>
              <td class="value">
                {{ provider }}
              </td>
            </tr>
            <tr class="row check-sim-card-row sim-type">
              <td class="text">
                <slot name="lblFormat">Format</slot>
              </td>
              <td class="value " :class="simType">
                <slot name="valueFormatEsim" v-if="simType === 'E_SIM'">eSIM</slot>
                <slot name="valueFormat" v-else>SIM</slot>
              </td>
            </tr>
            <tr class="row check-sim-card-row sim-state">
              <td class="text">
                <slot name="lblSimStatus">Status aktuelle Sim</slot>
                <a class="info-link-icon" @click="openInfoModal('sim')"></a>
              </td>
              <td class="value">
                <slot name="lblSimStatusInactive" v-if="simStatus === 'INACTIVE'">Inaktiv</slot>
                <slot name="lblSimStatusCanceled" v-else-if="simStatus === 'CANCELED'">Inaktiv</slot>
                <slot name="lblSimStatusPassivated" v-else-if="simStatus === 'PASSIVATED'">Passiviert</slot>
                <slot name="lblSimStatusSuspended" v-else-if="simStatus === 'SUSPENDED'">Suspendiert</slot>
                <slot name="lblSimStatusActive" v-else>aktiv</slot>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card-wrapper" v-if="showCheckEsim && eSimInstalled">
      <div class="card removeESim">
        <div><slot name="txtRemoveESim">eSIM vom Gerät entfernen</slot></div>
        <div><button @click="openInfoModal('esimInstalled')"><slot name="lblRemoveESim">Lorem, ipsum.</slot></button></div>
      </div>
    </div>
  </div>
</template>
<script>

import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import transaction from '@/mixins/transaction'
import SimonModal from '@/components/modal/SimonModal.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'ViewCheckSimCard',
  components: { SimonModal },
  mixins: [
    transaction('checkSIMCard')

  ],
  data: function () {
    return {
      currentCustomer: null,
      mnpOutStatus: null,
      eSimStatus: null,
      showCheckEsim: false,
      identMethodsLoaded: false,
      eSimStatusLoaded: false,
      statusInfoModal: 'sim',
      showStatusInfoModal: false
    }
  },
  mounted () {
    this.startLoader()
  },
  methods: {
    checkAndDisableLoader () {
      if (this.identMethodsLoaded && this.eSimStatusLoaded) {
        this.stopLoader()
      }
    },
    openInfoModal (target) {
      this.statusInfoModal = target
      this.showStatusInfoModal = true
      let name = ''
      if (target === 'esim') {
        name = 'info esim device binding'
      } else if (target === 'sim') {
        name = 'info current sim state'
      } else if (target === 'esimInstalled') {
        name = 'info remove esim'
      }
      if (typeof window.trackingNS?.track?.trackInformation === 'function') {
        window.trackingNS.track.trackInformation(name, 'reveal', 'overlay', 'icon')
      }
    },
    ...mapMutations('substituteSimCard', [
      'setEsimInstalled',
      'setSimCardType'
    ])
  },
  computed: {
    simType: function () {
      return this.currentCustomer?.contract?.simCard?.type || 'SIM_CARD'
    },
    iccId: function () {
      return this.currentCustomer?.contract?.simCard?.iccId
    },
    pukView: function () {
      return this.currentCustomer?.contract?.simCard?.puk
    },
    provider: function () {
      return this.mnpOutStatus?.serviceProviderCode
    },
    eSimInstalled: function () {
      return this.eSimStatus?.eSimStatus === 'INSTALLED'
    },
    eID: function () {
      return this.eSimStatus?.eid
    },
    simStatus: function () {
      return this.eSimStatus?.simStatus || this.currentCustomer?.contract?.simCard?.status
    },
    eSimUnavailable: function () {
      return this.eSimStatus?.eSimStatus === 'UNAVAILABLE' || this.eSimStatus?.eSimStatus === 'UNAVAILABLE '
    }
  },
  props: {
    esimPushTargetUrl: {
      type: String,
      default: ''
    }
  },
  apollo: {
    allIdentMethods: function () {
      return wrapQuery(gql`query checkSIMCard {
        currentCustomer {
          contract {
            simCard {
              iccId
              puk
              status
              type
            }
          }
        }
        mnpOutStatus {
            serviceProviderCode
        }
      }`, this, ['currentCustomer', 'mnpOutStatus'], {}, () => {
        if (!this.$apollo.queries.allIdentMethods.loading) {
          this.identMethodsLoaded = true
          this.checkAndDisableLoader()
        }
      })
    },
    eSimStatus: function () {
      return wrapQuery(gql`query eSimStatus {
        eSimStatus {
          eid
          eSimStatus
          simStatus
          success
        }
      }`, this, ['eSimStatus'], {}, () => {
        if (!this.$apollo.queries.eSimStatus.loading) {
          this.eSimStatusLoaded = true
          if (this.eSimStatus.success && this.eSimStatus.eSimStatus) {
            this.showCheckEsim = true
          } else {
            this.showCheckEsim = false
          }
          const eSimInstalledValue = this.eSimInstalled
          this.setEsimInstalled(eSimInstalledValue)
          this.setSimCardType(this.simType)
          this.checkAndDisableLoader()
        }
      }, {
        skip: () => {
          this.eSimStatusLoaded = true
          this.showCheckEsim = false
          this.checkAndDisableLoader()
          return this.simType !== 'E_SIM'
        }
      },
      () => {
        this.eSimStatusLoaded = true
        this.showCheckEsim = false
        this.checkAndDisableLoader()
      })
    }
  }
}
</script>
